<ol class="breadcrumb">
    <li>
      <a [routerLink]="['/submissions']">
        Submissions
      </a>
        /  Sample Search Results
    </li>
  </ol>
<div *ngIf="userInfo">
<table aria-describedby="Sample Search Table" class="table sample-search-table table-striped table-hover">
<thead>
    <tr>
      <th scope="col" class="review-header"> </th>
      <th scope="col" class="hmlid-header">HML ID</th>
      <th scope="col" class="sampleid-header">Sample ID</th>
      <th scope="col" class="test-results-header">Test Results</th>
      <th scope="col" class="status-header">Status</th>
      <th scope="col" class="received-header">Received (CST)</th>
      <th scope="col" class="test-type-header">Test Type</th>
      <th scope="col" class="reporting-center-header">Center Code</th>
      <th scope="col" class="project-name-header">Project Name</th>
    </tr>
  </thead>
  <tbody>
      <tr *ngFor="let sample of activeFileRecordList">
        <td class="review-cell">
            <mat-checkbox color="primary" [checked]="sample.revInd"  (change)="review($event.checked,sample.docidGuid, sample.sampleId)"></mat-checkbox>
        </td>
        <td class="hmlid-cell">
            <div class="hmlid-container">
                <span class="click-me" matTooltip={{sample.hmlId}}  (click)="displaySubmissionSourceDialog(sample.docidGuid, sample.hmlId, sample.fileName, sample.statusCde, sample.testTypeCde)">{{sample.hmlId}}</span>
            </div>
            <mat-icon [routerLink]="['/submissions/submission',sample.docidGuid]" matTooltip="FHIR Sample Data Available" *ngIf="sample.fhirInd || isDsa(sample.testTypeCde)" svgIcon="fhir" class="material-icons--outline icon fhir"></mat-icon>
            <mat-icon matTooltip="Correction" class="material-icons--outline icon corrections" *ngIf="sample.corrInd">create
            </mat-icon>
        </td>
        <td class="sampleid-cell"><span class="click-me" (click)="displaySourceDialog(sample.docidGuid, sample.sampleId, sample.testTypeCde)">{{sample.sampleId}}</span></td>
        <td class="test-results-cell">
            <a [routerLink]="['/submissions/submission',sample.docidGuid,'sample',sample.sampleId]"><div class="test-results-button"><span class="test-results-count">{{sample.testResults}}</span></div></a>
        </td>
            <td *ngIf="sample.statusCde === 'Success' || (!userInfo.internalUser && sample.statusCde != 'Failed') ; else showErrorIcn" class="sample-status-cell">
                <div class="sample-status">{{sample.statusCde}}</div>
            </td>
            <ng-template #showErrorIcn>
                <td class="sample-status-cell">
                    <mat-icon class="icon info" [hidden]="!sample.statusCde" (click)="displaySampErrorDialog(sample.docidGuid,sample.sampleId)">error_outline</mat-icon>
                    <div class="status-cell">{{sample.statusCde}}</div>
                </td>
            </ng-template>
        <td class="received-cell">{{sample.receivedDte}}</td>
        <div *ngIf="sample.testTypeCde==='Blood Group Antigens'; then thenBlock else elseBlock"></div>
            <ng-template #thenBlock><td class="test-type-cell" >BGA</td></ng-template>
            <ng-template #elseBlock><td class="test-type-cell" >{{sample.testTypeCde}}</td></ng-template>
        <td class="reporting-center-cell">{{sample.centerCde}}</td>
        <td class="project-name-cell">{{sample.projectNme}}</td>
    </tr>
    <p class="empty-search" *ngIf="activeFileRecordList != null && activeFileRecordList.length === 0">No results found for search criteria entered</p>
  </tbody>
</table>
    <div class="table-tools">
        <div class="extract-button" #extractButton (click)="extract()">
            <em class="material-icons file-dwnld">file_download</em>Extract
        </div>
        <div>
            <div class="pagination-button">
                <samplepagination></samplepagination>
            </div>
        </div>
    </div>
</div>

<modal-component #sampleSource
                 [title]="sourceModalTitle"
                 [data]="{
                  resizeOrClose:'close',
                  okBtnTitle:'OK',
                  okBtnCssClass:'btn btn-primary',
                  cancelBtnTitle: '',
                  editBtnTitle: '',
                  resubmitBtnTitle: ''}">
    <div class="hml-sample-source">{{sampleSourceDisplay()}}</div>
</modal-component>

<modal-component #errorDialog
    [title]="errorModalTitle"
    [data]="{
        resizeOrClose:'close',
        okBtnTitle:'',
        cancelBtnTitle: '',
        editBtnTitle: '',
        resubmitBtnTitle: '',
        footerMessage: 'Access your original file to correct errors. Submit a corrected file.'
    }">
    <div class="error-table">
        <div class="error-header-row">
            <span class="error-location-hdr">Error&nbsp;Location</span>
            <span class="error-desc-hdr">Description</span>
        </div>
        <div *ngFor="let error of errorDetails" class="error-details-row">
            <span *ngIf="error.errorLocation === 'Sample '.concat(modalSampleId)" class="error-location-cell">{{error.errorLocation}}</span>
            <span *ngIf="error.errorLocation === 'Sample '.concat(modalSampleId)" class="error-desc-cell">{{error.errorDescription}}</span>
        </div>
    </div>
</modal-component>


<pandora-aside [title]="'Submission Info'" [isToggleAvailable]=true></pandora-aside>
